import { render, staticRenderFns } from "./messageBottom.vue?vue&type=template&id=04557c98&scoped=true"
import script from "./messageBottom.vue?vue&type=script&lang=js"
export * from "./messageBottom.vue?vue&type=script&lang=js"
import style0 from "./messageBottom.vue?vue&type=style&index=0&id=04557c98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04557c98",
  null
  
)

export default component.exports